import getConfig from 'next/config'

export interface IAddressLookupData {
    street: string
    secondary?: string
    city?: string
    state?: string
    zipCode?: string
}

const { publicRuntimeConfig } = getConfig()
const SmartyStreetsSDK = require('smartystreets-javascript-sdk')
const SmartyStreetsCore = SmartyStreetsSDK.core
const Lookup = SmartyStreetsSDK.usAutocompletePro.Lookup
const credentials = new SmartyStreetsCore.SharedCredentials(
    publicRuntimeConfig.smartyEmbeddedKey,
    publicRuntimeConfig.smartyEmbeddedHostname
)

const autocompleteLookup = async (
    lookupAddressData: IAddressLookupData,
    selectedAddressData?: string
) => {
    const addressString = Object.values(lookupAddressData).join(' ')
    const clientBuilder = new SmartyStreetsCore.ClientBuilder(
        credentials
    ).withLicenses(['us-autocomplete-pro-cloud'])
    const client = clientBuilder.buildUsAutocompleteProClient()
    const lookup = new Lookup(addressString)
    lookup.selected = selectedAddressData

    return await client
        .send(lookup)
        .then(function (results: any) {
            return results.result
        })
        .catch((error: any) => {
            console.error(error)
            return null
        })
}

const addressLookup = async (addressData: IAddressLookupData) => {
    const clientBuilder = new SmartyStreetsCore.ClientBuilder(
        credentials
    ).withLicenses(['us-rooftop-geocoding-cloud', 'us-core-cloud'])
    const client = clientBuilder.buildUsStreetApiClient()

    const lookup = new Lookup()
    lookup.street = addressData.street
    lookup.secondary = addressData.secondary
    lookup.city = addressData.city
    lookup.state = addressData.state
    lookup.zipCode = addressData.zipCode
    lookup.maxCandidates = 5
    lookup.match = 'strict'

    const batch = new SmartyStreetsCore.Batch()
    batch.add(lookup)

    return await client
        .send(batch)
        .then((result: any) => {
            return result.lookups[0].result[0]
        })
        .catch((response: any) => {
            // Sentry.captureException(response)
            return null
        })
}

export const smarty = async (
    lookupAddressData: IAddressLookupData,
    selectedAddressData?: string,
    useBatchLookup?: boolean
) => {
    if (useBatchLookup) {
        return addressLookup(lookupAddressData)
    }
    return autocompleteLookup(lookupAddressData, selectedAddressData)
}
